export enum LoginStatus{
    inactive,
    lookingForAccounts,
    popupLogin,
    redirectLogin
}